// @flow
import * as React from 'react';
import { IAuthResponse, IFreeRoom, emptyRoom } from '../../Interfaces';
import { useSelector } from 'react-redux';
import { getHistoryLocationRoomspace } from '../../Data/ApiRequests';
import { formattedDateTime } from '../../Helpers/TimeMethods';
import { RommspaceInfo } from '../RommspaceInfo/RommspaceInfo';
type Props = {
  wnummer: string

};
export function GetHistoryLocation(props: Props) {
  //const { wnummer } = {...props};
  const wnummer = props.wnummer ?? ''
  const historyRef = React.useRef<HTMLDivElement>(null)
  const selectedRoomspaceIdRef = React.useRef('')
  const [historyRoomspaces, setHistoryRoomspaces ]= React.useState<IFreeRoom[]>();
  const [historyRoomspace, setHistoryRoomspace ]= React.useState<IFreeRoom>(emptyRoom);
  const bearerToken: IAuthResponse = useSelector((state: IAuthResponse) => state)
  const [selectedRoomspaceId, setSelectedRoomspaceId] = React.useState('');

React.useEffect( () => {
  const fetchData = async (wnummer:string) => {
    getHistoryLocationRoomspace(wnummer, bearerToken.token)
        .then( (response) => {
            setHistoryRoomspaces(response)
        }).catch(error => {
            console.log('Error.' + error)
        });
};
    if(wnummer !== '') fetchData(wnummer)
}, [wnummer, bearerToken.token]);

const showHistory = (roomspaceId: string | undefined):void => {
  if(historyRoomspaces !== undefined) {
    const selectedHistories = historyRoomspaces.filter(x=>x.roomspaceId === roomspaceId)
    if(selectedHistories.length > 0 ) {
      setHistoryRoomspace(selectedHistories[0])
    }
  }
}

  return (
    <div>
          {
            (historyRoomspaces !== undefined && historyRoomspaces.length > 0) &&
            <ul style={{ padding: 0}}>
              <h2 style={{lineHeight: 1, paddingBottom: '3px'}}>Freiplatzmeldungen Historie<br />
              <label style={{fontSize: 13}}>(letzte 10 Datensätze)</label></h2>
        {
          historyRoomspaces?.map( (hroomspace) => {
            return (
              <li  key={`his${hroomspace.roomspaceId}`} style={{listStyle: '', padding: '0'}}>
                <button
                className={ (selectedRoomspaceIdRef.current === hroomspace.roomspaceId) ? 'historyListBtnB'  : 'historyListBtn' }
                style={{paddingLeft: 20}}
                onClick={() => {
                  showHistory (hroomspace.roomspaceId)
                  if (selectedRoomspaceId === hroomspace.roomspaceId) {
                    setSelectedRoomspaceId('')
                    selectedRoomspaceIdRef.current = ''


                  } else {
                    setSelectedRoomspaceId(hroomspace.roomspaceId??'')
                    selectedRoomspaceIdRef.current = hroomspace.roomspaceId ?? ''
                      setTimeout(() => {
                        historyRef.current?.scrollIntoView( { behavior: 'smooth'})
                      }, (100));
                  }

                }}
                >{formattedDateTime(hroomspace.lastUpdate)}</button>
                {selectedRoomspaceIdRef.current === hroomspace.roomspaceId && (
                <div ref={historyRef}>
                  <RommspaceInfo   isHistory={true} wnummer={wnummer} historyRoomspace={historyRoomspace} /></div>
                )}
                </li>
            )
          })
        }
            </ul>

          }


    </div>
  );
};